import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-69816bda")

_pushScopeId("data-v-69816bda")
const _hoisted_1 = { class: "main__section" }
const _hoisted_2 = { class: "-bold" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_RequestView = _resolveComponent("RequestView")
  const _component_CancelConfirm = _resolveComponent("CancelConfirm")

  return (_openBlock(), _createBlock("main", null, [
    _createVNode("section", _hoisted_1, [
      _createVNode(_component_RequestView, {
        isQuick: _ctx.state.isQuick,
        id: _ctx.state.id,
        onDeletedFile: _ctx.onDeletedFile,
        onCancelRequest: _cache[1] || (_cache[1] = (id)=>{_ctx.CancelRequest(id)})
      }, {
        title: _withId(() => [
          _createVNode("h2", _hoisted_2, _toDisplayString(_ctx.t("requested detail information")), 1)
        ]),
        _: 1
      }, 8, ["isQuick", "id", "onDeletedFile"]),
      _createVNode(_component_CancelConfirm, {
        ref: "cancel$",
        accept: _ctx.CancelAccept
      }, null, 8, ["accept"])
    ])
  ]))
})